import React from "react"

export default function List() {
  return (
    <symbol id="svg-list" viewBox="0 0 24 24">
      <path d="M21.3334 16H7.33337V18H21.3334V16Z" fill="currentColor" />
      <path d="M5.33337 16H3.33337V18H5.33337V16Z" fill="currentColor" />
      <path d="M21.3334 11H7.33337V13H21.3334V11Z" fill="currentColor" />
      <path d="M5.33337 11H3.33337V13H5.33337V11Z" fill="currentColor" />
      <path d="M21.3334 6H7.33337V8H21.3334V6Z" fill="currentColor" />
      <path d="M5.33337 6H3.33337V8H5.33337V6Z" fill="currentColor" />
    </symbol>
  )
}
